import { doc, getDoc } from "firebase/firestore";
import { db } from "./authService";

export const getHouseScanWeeklyVideo = async () => {
  const docRef = doc(db, "houseScanVideos", "weeklyVideo");
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    return docSnap.data().videoLink;
  } else {
    console.error("No such document!");
    return null;
  }
};
